import { NgModule } from '@angular/core';
import { SmartBannerStoreModule } from './store/smart-banner-store.module';

@NgModule({
  imports: [SmartBannerStoreModule],
})
export class SmartBannerDataAccessModule {}
